import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "doc-upload-wrapper w-100 position-relative" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex flex-column flex-lg-row align-items-center" }
const _hoisted_7 = { style: {"max-width":"2rem"} }
const _hoisted_8 = { class: "file-preview ms-2" }
const _hoisted_9 = { class: "w-100 h-100 d-flex align-items-center justify-content-center" }

import { ref } from "vue";

import { Button } from "@/components/global";
import { PdfDocIcon, PdfPictureIcon, FileThrashIcon } from "@/components/svg";

import { InputVariant } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    label: {},
    labelIcon: {},
    variant: {},
    filePreview: {},
    id: {}
  },
  emits: ["change", "removeFile"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const inputRef = ref<HTMLInputElement | null>(null);

const onChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files;
  if (files) {
    emit('change', files);
  }

  (e.target as HTMLInputElement).value = '';
};

const handleRemove = () => {
  emit('removeFile');
};

const handleDrop = (e: DragEvent) => {
  const files = e.dataTransfer?.files;

  if (files && files[0]?.type === "application/pdf") {
    emit('change', files);

    if (inputRef.value) inputRef.value.value = '';
  }
};

__expose({ inputRef });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex align-items-center", __props.variant === 'admin' ? 'admin-doc-upload-label' : 'doc-upload-label'])
    }, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      (__props.labelIcon)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.labelIcon), {
            key: 0,
            class: "ms-1"
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("input", {
      id: __props.id,
      ref_key: "inputRef",
      ref: inputRef,
      class: "d-none",
      type: "file",
      accept: ".pdf",
      onChange: onChange,
      "data-testid": "input-fileInput"
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: __props.id,
      class: _normalizeClass(["doc-upload-default d-flex align-items-center justify-content-center p-4", __props.variant === 'admin' ? 'admin-doc-upload' : 'doc-upload']),
      style: _normalizeStyle([__props.filePreview ? { background: 'rgba(28, 86, 145, 0.05)' } : {}]),
      onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onDragenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      onDrop: handleDrop
    }, [
      (!__props.filePreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(PdfDocIcon)),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "drag-file-wrapper" }, [
              _createTextVNode(" Drag file here to Upload "),
              _createElementVNode("br"),
              _createTextVNode(" or "),
              _createElementVNode("span", { style: {"color":"var(--ch-blue-100)"} }, "Choose File")
            ], -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(PdfPictureIcon))
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString(__props.filePreview), 1)
            ]),
            _createVNode(_unref(Button), {
              variant: "naked",
              class: "file-thrash-wrapper",
              onClick: handleRemove,
              testId: "remove-file-btn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(FileThrashIcon))
                ])
              ]),
              _: 1
            })
          ]))
    ], 46, _hoisted_3)
  ]))
}
}

})